export enum TitleBacklightColors {
  Blue = 'Blue',
  DarkMint = 'Dark Mint',
  Magenta = 'Magenta',
  SecondaryBlue = 'Secondary Blue',
}

export type HeaderSectionProps = {
  title: string;
  hasPageCategory: boolean;
  titleBacklight?: TitleBacklightColors;
  href?: string;
  countArticles?: number;
  hasIcon?: boolean;
};
